<template>
  <!-- the expanded view of one alert record: everything the row/card face
       trims. rendered by alert_list.vue in two places -- inside the desktop
       table's row-details slot and inside a mobile card -- so the two can't
       drift apart as fields are added. -->
  <div class="adb">
    <div v-if="item.email" class="adb-block">
      <b>email recipients:</b> {{ item.email }}
    </div>

    <div v-if="item.email_subject" class="adb-block">
      <b>email subject:</b> {{ item.email_subject }}
    </div>

    <div v-if="item.email_message" class="adb-block">
      <b>email message:</b>
      <div class="adb-rich" v-html="item.email_message"/>
    </div>

    <div v-if="item.sms_all_recipients" class="adb-block recipients-list">
      <b>SMS recipients:</b> {{ item.sms_all_recipients }}
    </div>

    <div v-if="isHtmlMessage" class="adb-block">
      <b>{{ bodyLabel }}</b>
      <div class="adb-rich" v-html="item.message"/>
    </div>
    <div v-else-if="item.message" class="adb-block">
      <b>{{ bodyLabel }}</b>
      <pre class="adb-pre">{{ item.message }}</pre>
    </div>

    <div v-if="item.prev_message" class="adb-block">
      <b>previous message:</b>
      <pre class="adb-pre">{{ item.prev_message }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'alert_detail_body',
  props: {
    item: { type: Object, required: true },
    // what to call the message body for this alert type -- the caller owns
    // that wording (messageBodyLabel in alert_list.vue)
    bodyLabel: { type: String, default: 'message:' },
  },
  computed: {
    isHtmlMessage() {
      return (this.item.message || '').indexOf('<html') !== -1
    },
  },
}
</script>

<style scoped>
.adb {
  text-align: left;
}

.adb-block + .adb-block {
  margin-top: 10px;
}

/* tenant-authored email bodies: they carry their own markup, so this only
   keeps them inside the card rather than styling them */
.adb-rich {
  margin-top: 4px;
  font-family: monospace;
  white-space: normal !important;
  max-width: 100%;
  overflow-x: auto;
}

/* the plain-text bodies wrap here rather than forcing a 2100px scroll box
   the way the old inline markup did -- a phone card has no such width to
   give, and on desktop the row-details panel is already full width */
.adb-pre {
  margin: 4px 0 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12.5px;
}
</style>
